import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateformat'
})
export class DateformatPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {
  }

  /**
   * Transforms get date time convert pipe
   * @param value input value
   * @param [args] input param
   * @returns transform format value
   * @author phuongqt
   */
  transform(value: any, args?: any): any {
    return this.datePipe.transform(value, 'dd/MM/yyyy HH:mm:ss');
  }
}
